<template>
  <div class="selectTimer flex-ac flex-start">
    <el-radio-group v-model="type" size="mini" v-if="tags.length > 1">
      <el-radio-button v-if="tags.indexOf('分钟') > -1" :label="'1min'"
        >分钟</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('时') > -1" :label="'hour'"
        >时</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('日') > -1" :label="'day'"
        >日</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('周') > -1" :label="'week'"
        >周</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('月') > -1" :label="'month'"
        >月</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('季') > -1" :label="'quarter'"
        >季</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('年') > -1" :label="'year'"
        >年</el-radio-button
      >
      <el-radio-button v-if="tags.indexOf('自选时段') > -1" :label="'custom'"
        >自选时段</el-radio-button
      >
    </el-radio-group>
    <p style="width: 10px; height: 10px" v-if="tags.length > 1" />
    <div :style="sum == 2 ? '370px' : '180px'" class="flex-sb">
      <el-date-picker
        @blur="emit"
        @focus="focus1"
        v-show="selectType === null"
        :picker-options="pickerOptions"
        size="mini"
        v-model="sj[0]"
        type="datetime"
        :default-time="$formatDate(new Date(sj[0]), 'hh:mm:ss')"
        placeholder="选择开始时间"
        format="yyyy/MM/dd HH:mm"
        value-format="yyyy/MM/dd HH:mm"
      />
      <el-date-picker
        @blur="emit"
        @focus="focus2"
        v-show="selectType === null"
        v-if="sum == 2"
        :picker-options="pickerOptions"
        size="mini"
        v-model="sj[1]"
        type="datetime"
        :default-time="$formatDate(new Date(sj[1]), 'hh:mm:ss')"
        placeholder="选择结束时间"
        format="yyyy/MM/dd HH:mm"
        value-format="yyyy/MM/dd HH:mm"
      />
      <template v-if="selectType == '1min' && tags.indexOf('分钟') > -1">
        <el-date-picker
          @blur="emit"
          @focus="focus1"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[0]"
          type="datetime"
          :default-time="$formatDate(new Date(sj[0]), 'hh:mm:ss')"
          placeholder="选择开始时间"
          format="yyyy/MM/dd HH:mm:ss"
          value-format="yyyy/MM/dd HH:mm:ss"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <el-date-picker
          @blur="emit"
          @focus="focus2"
          v-if="sum == 2"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[1]"
          type="datetime"
          :default-time="$formatDate(new Date(sj[1]), 'hh:mm:ss')"
          placeholder="选择结束时间"
          format="yyyy/MM/dd HH:mm:ss"
          value-format="yyyy/MM/dd HH:mm:ss"
        />
      </template>
      <template v-if="selectType == 'hour' && tags.indexOf('时') > -1">
        <el-date-picker
          popper-class="hh_popper-class"
          @blur="emit"
          @focus="focus1"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[0]"
          type="datetime"
          :default-time="$formatDate(new Date(sj[0]), 'hh:mm:ss')"
          placeholder="选择开始时间"
          format="yyyy/MM/dd HH:mm"
          value-format="yyyy/MM/dd HH:mm"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <el-date-picker
          popper-class="hh_popper-class"
          @blur="emit"
          @focus="focus2"
          v-if="sum == 2"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[1]"
          type="datetime"
          :default-time="$formatDate(new Date(sj[1]), 'hh:mm:ss')"
          placeholder="选择结束时间"
          format="yyyy/MM/dd HH:mm"
          value-format="yyyy/MM/dd HH:mm"
        />
      </template>
      <template v-if="selectType == 'day' && tags.indexOf('日') > -1">
        <el-date-picker
          @blur="emit"
          @focus="focus1"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[0]"
          type="date"
          placeholder="选择日"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <el-date-picker
          @blur="emit"
          @focus="focus2"
          v-if="sum == 2"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[1]"
          type="date"
          placeholder="选择日"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
        />
      </template>
      <template v-if="selectType == 'week' && tags.indexOf('周') > -1">
        <el-date-picker
          @blur="emit"
          @focus="focus1"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[0]"
          type="week"
          placeholder="选择日"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <el-date-picker
          @blur="emit"
          @focus="focus2"
          v-if="sum == 2"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[1]"
          type="week"
          placeholder="选择日"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
        />
      </template>
      <template v-if="selectType == 'month' && tags.indexOf('月') > -1">
        <el-date-picker
          @blur="emit"
          @focus="focus1"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[0]"
          type="month"
          placeholder="选择月份"
          format="yyyy/MM"
          value-format="yyyy/MM/dd"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <el-date-picker
          @blur="emit"
          @focus="focus2"
          v-if="sum == 2"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[1]"
          type="month"
          placeholder="选择月份"
          format="yyyy/MM"
          value-format="yyyy/MM/dd"
        />
      </template>
      <template v-if="selectType == 'quarter' && tags.indexOf('季') > -1">
        <weekSelect
          :className="'weekSelectInput1'"
          @func="startWeek"
          :date="sj[0]"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <weekSelect
          :className="'weekSelectInput2'"
          @func="endWeek"
          :date="sj[1]"
          v-if="sum == 2"
        />
      </template>
      <template v-if="selectType == 'year' && tags.indexOf('年') > -1">
        <el-date-picker
          @blur="emit"
          @focus="focus1"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[0]"
          type="year"
          placeholder="选择年份"
          format="yyyy"
          value-format="yyyy/MM/dd"
        />
        <p style="width: 10px; height: 10px" v-if="sum == 2" />
        <el-date-picker
          @blur="emit"
          @focus="focus2"
          v-if="sum == 2"
          :picker-options="pickerOptions"
          size="mini"
          v-model="sj[1]"
          type="year"
          placeholder="选择年份"
          format="yyyy"
          value-format="yyyy/MM/dd"
        />
      </template>
      <template v-if="selectType == 'custom' && tags.indexOf('自选时段') > -1">
        <el-date-picker
          @blur="emit"
          @focus="focus1"
          size="mini"
          v-model="sj[0]"
          type="date"
          placeholder="选择日"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
        />
        <p style="width: 10px; height: 10px" />
        <el-date-picker
          @blur="emit"
          @focus="focus2"
          size="mini"
          v-model="sj[1]"
          type="date"
          placeholder="选择日"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { format } from "d3";
import { mapGetters } from "vuex";
export default {
  props: ["sum", "timeObj", "tags", "timeType", "time"],
  components: {},
  computed: {
    ...mapGetters(["tabsOn", "auditCalendar_queryDate"]),
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: (time) => time.getTime() > Date.now(),
      },
      sj: [new Date(), new Date()],
      type: "",
      selectType: "",
      his: [null, null],
      format: {
        "1min": "yyyy/MM/dd HH:mm:ss",
        hour: "yyyy/MM/dd HH:mm",
        day: "yyyy/MM/dd",
        week: "yyyy/MM/dd",
        month: "yyyy/MM/01",
        quarter: "yyyy/MM/01",
        year: "yyyy/01/01",
        custom: "yyyy/MM/dd",
      },
    };
  },
  watch: {
    tabsOn(v) {
      if (v.path == "networkDataValidRate") {
      }
    },
    timeObj(v) {
      if (this.tabsOn.path == "auditCalendar") {
        this.sj = [v.StartTime_day, v.EndTime_day];
      }
    },
    ylts_timeType(v) {
      if (v && this.tabsOn.path == "stationGoodDaysReport") {
        this.sj = this.ylts_time;
      }
    },
    ylts_time(v) {
      if (v && this.tabsOn.path == "stationGoodDaysReport") this.sj = v;
    },
    time(v) {
      this.sj = v;
      if (v && this.tabsOn.path == "auditDayDatas") {
        this.emit();
      }
      if (
        v &&
        (this.tabsOn.path == "networkDataAcquisitionRate" ||
          this.tabsOn.path == "networkDataValidRate")
      ) {
        this.emit();
      }
    },
    type(v) {
      this.$parent.fxlx = v;
      this.selectType = null;
      setTimeout(() => {
        this.selectType = v;
        this.sj[0] = new Date(this.timeObj["StartTime_" + v] || new Date());
        this.sj[1] = new Date(this.timeObj["EndTime_" + v] || new Date());
        this.his[0] =
          new Date(this.timeObj["StartTime_" + v] || new Date()) || null;
        this.his[1] =
          new Date(this.timeObj["EndTime_" + v] || new Date()) || null;
        if (
          this.tabsOn.path == "analysisAqiCalendarCompare" &&
          this.AQIdbt_time
        ) {
          this.sj = this.AQIdbt_time;
        }
        if (this.tabsOn.path == "stationGoodDaysReport" && this.ylts_time) {
          this.sj = this.ylts_time;
        }
        if (
          this.tabsOn.path == "auditDayDatas" &&
          this.auditCalendar_queryDate
        ) {
          this.sj = [
            this.auditCalendar_queryDate,
            this.auditCalendar_queryDate,
          ];
        }
        this.$emit("emitTimer", this.sj);
      });
    },
    // sj(v) {
    //   this.$emit("emitTimer", v);
    // },
    AQIdbt_time(v) {
      if (v) {
        this.sj = [
          this.AQIdbt_time
            ? this.AQIdbt_time[0]
            : new Date(this.timeObj["StartTime_" + v]),
          this.AQIdbt_time
            ? this.AQIdbt_time[1]
            : new Date(this.timeObj["EndTime_" + v]),
        ];
      }
    },
    timeType(v) {
      this.type = v;
    },
    selectType() {
      // this.resKjxx();
    },
  },
  mounted() {
    this.type = this.timeType;
    this.selectType = this.timeType;
    this.his[0] =
      new Date(this.timeObj["StartTime_" + this.selectType] || new Date()) ||
      null;
    this.his[1] =
      new Date(this.timeObj["EndTime_" + this.selectType] || new Date()) ||
      null;
  },
  methods: {
    focus1(e) {
      this.his[0] = +new Date(e.value);
      this.resKjxx();
    },
    focus2(e) {
      this.his[1] = +new Date(e.value);
      this.resKjxx();
    },
    startWeek(v) {
      this.sj[0] = new Date(v);
      this.emit();
    },
    endWeek(v) {
      this.sj[1] = new Date(v);
      this.emit();
    },
    emit(e) {
      if (
        this.sum == 2 &&
        +new Date(
          this.$formatDate(new Date(this.sj[0]), this.format[this.selectType])
        ) >
          +new Date(
            this.$formatDate(new Date(this.sj[1]), this.format[this.selectType])
          )
      ) {
        this.$notify({
          position: "bottom-right",
          title: "提示",
          message: "结束时间不可小于开始时间",
          type: "info",
        });
        return;
      }
      if (
        +new Date(this.sj[0]) != +new Date(this.his[0]) ||
        (this.sj[1] &&
          this.his[1] &&
          +new Date(this.sj[1]) != +new Date(this.his[1]))
      ) {
        this.his[0] = new Date(this.sj[0]);
        this.his[1] = new Date(this.sj[1]);
        this.$emit("emitTimer", this.sj);
      }
    },
    resKjxx() {
      const date = new Date();
      let obj = {
        "1min": [
          { text: "现在", date: new Date() },
          { text: "30分钟前", date: new Date(+date - 1000 * 60 * 30) },
          { text: "1小时前", date: new Date(+date - 3600 * 1000) },
        ],
        hour: [
          { text: "现在", date: new Date() },
          { text: "6小时前", date: new Date(+date - 3600 * 1000 * 6) },
          { text: "24小时前", date: new Date(+date - 3600 * 1000 * 24) },
        ],
        day: [
          { text: "今天", date: new Date() },
          { text: "昨天", date: new Date(+date - 3600 * 1000 * 24) },
          { text: "一周前", date: new Date(+date - 3600 * 1000 * 24 * 7) },
        ],
        week: [
          { text: "本周", date: new Date() },
          { text: "上周", date: new Date(+date - 3600 * 1000 * 24 * 7) },
          { text: "1个月前", date: new Date(+date - 3600 * 1000 * 24 * 30) },
        ],
        month: [
          { text: "本月", date: new Date() },
          {
            text: "1个月前",
            date: new Date(
              +`${
                +new Date(this.$formatDate(new Date(), "yyyy/MM/01")) -
                1000 * 3600 * 24 * 30
              }`
            ),
          },
          {
            text: "3个月前",
            date: new Date(
              +`${
                +new Date(this.$formatDate(new Date(), "yyyy/MM/01")) -
                1000 * 3600 * 24 * 90
              }`
            ),
          },
          {
            text: "6个月前",
            date: new Date(
              +`${
                +new Date(this.$formatDate(new Date(), "yyyy/MM/01")) -
                1000 * 3600 * 24 * 180
              }`
            ),
          },
        ],
        quarter: [],
        year: [
          { text: "今年", date: new Date() },
          {
            text: "去年",
            date: new Date(`${this.$formatDate(new Date(), "yyyy") - 1}/01/01`),
          },
          {
            text: "前年",
            date: new Date(`${this.$formatDate(new Date(), "yyyy") - 2}/01/01`),
          },
        ],
        custom: [],
      };
      if (this.type == "custom") {
        this.pickerOptions.shortcuts = [];
        return;
      }
      this.pickerOptions.shortcuts = [];
      obj[this.type].map((v) => {
        this.pickerOptions.shortcuts.push({
          text: v.text,
          onClick: (_this) => {
            _this.$emit("pick", v.date);
          },
        });
      });
      this.pickerOptions.shortcuts;
    },
  },
  destroyed() {},
};
</script>
<style lang='stylus' scoped>
.selectTimer {
  width: max-content;
  flex: 0;
}

.el-radio-group {
  width: max-content;
}

.selectTimer >>>.el-input__inner {
  width: 200px;
}

.selectTimer >>>.el-date-editor {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/selectTimer.vue